import {AppServices} from "../../config/entities";
import {IUniversalReportRequestDto} from "../../dtos/reports/universalReport/IUniversalReportRequestDto";
import {IUniversalReportResponseDto} from "../../dtos/reports/universalReport/IUniversalReportResponseDto";
import {IUniversalReportDto} from "../../dtos/reports/universalReport/IUniversalReportDto";

export class UniversalReportService {
    async generateUniversalReport(requestDto: IUniversalReportRequestDto): Promise<IUniversalReportResponseDto | undefined> {
        
        const response = await AppServices.Axios.post('/UniversalReports/GenerateUniversalReport', requestDto);
        if (response.status === 200) {
            return response.data;
        }
        
        return undefined;
    }
    
    async getAll(): Promise<IUniversalReportDto[] | undefined> {
        const response = await AppServices.Axios.get('/UniversalReports');
        if (response.status === 200) {
            return response.data;
        }
        
        return undefined;
    }
}